export const SET_SEARCH_TERM = 'SET_SEARCH_TERM';

export const setSearchTerm = (term) => ({
    type: SET_SEARCH_TERM,
    payload: term,
  });
  